const WLWishlistFunctions = {
  addToList: (target, product, _lid = false) => {
    function onSwymLoadCallback(swat) {
      // Please make all SWYM-related API calls inside this function.
      // You can use the swat argument within this scope.
      if (swat) {
        const lid  = target.dataset.lid ? target.lid : target.closest('unico-favorite-button').dataset.lid;
        if (_lid) {
          lid = _lid;
        }

        // Define success callback
        let onSuccess = function (addedListItem){
          // Success response is the added product. 
          console.log(`Successfully added the Product to List with lid ${lid}`, addedListItem);
        }

        // Define error callback
        let onError = function (error){
          // Error is an xhrObj
          console.log("Error while adding the Product to the List", error);
        }

        // Call `addToList` with the above callbacks, lid and product object
        swat.addToList(lid, product, onSuccess, onError);
      }
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
    
  },  
  fetchLists: () => {
    function onSwymLoadCallback(swat) {
      // Please make all SWYM-related API calls inside this function.
      // You can use the swat argument within this scope.
      
      if (swat) {
        // Define success callback
        
        let onSuccess = function(lists) {
          // Successfully fetched all lists 
          const currentList = lists.find(list => list.lname === 'unico wishlist');
          if(!currentList) {
            WLWishlistFunctions.createList();
            return;
          }
          for(let list of document.querySelectorAll('unico-favorite-button')) {
            list.dataset.lid = currentList.lid;
            document.querySelector('wl-wishlist-count').textContent = currentList.listcontents.length;
            document.querySelector('wl-wishlist-count').classList.remove('hidden');
            if(currentList.listcontents.find(item => item.epi == parseInt(list.dataset.variantId))) {
              list.querySelector('button[type="button"]').classList.add('-is-checked')
            } else {
              list.querySelector('button[type="button"]').classList.remove('-is-checked')
            }
          }
        }

        // Define error callback
        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error while fetching all Lists", error);
        }
        
        // Call `fetchLists` function
        swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });
      } 
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  },
  createList: (listConfig, onSuccess, onError) => {
    // Define the list config
    function onSwymLoadCallback(swat) {
      let listConfig = {
        "lname": "unico wishlist", // unique list name.
      };
      
      // Define success callback
      let onSuccess = function(newList) { 
        // Executed when a new list is successfully created
        console.log("Successfully created a new List", newList);
      }

      // Define error callback
      let onError = function(error) {
        // Error is an xhrObject
        console.log("Error while creating a List", error);
      }

      // Create a new list with the above callbacks and config
      swat.createList(listConfig, onSuccess, onError);
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  },
  removeFromWishList: (target, product) => {
    
    function onSwymLoadCallback(swat) {
      if(swat) {
        // Define the list id of the list to be updated
        const lid  = target.dataset.lid ? target.lid : target.closest('unico-favorite-button').dataset.lid;

        // Define success callback 
        let onSuccess = function(deletedProduct) {
          // Executed when product is successfully deleted
          console.log("Successfully deleted the Product", deletedProduct);
        }

        // Define error callback 
        let onError = function(error) {
          // Error is an xhrObject
          console.log("Error while deleting the Product", error);
        }

        // Call `deleteFromList` using the above callbacks, lid and listItem
        swat.deleteFromList(lid, product, onSuccess, onError);
      }
    }
    

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  },
  fetch: (callbackFn, errorFn) => {},
}
document.addEventListener('DOMContentLoaded', () => {
setTimeout(() => {
  WLWishlistFunctions.fetchLists()
}, 500)
})
/**
 * お気に入りボタン
 *  - お気に入り済みにする場合は、属性値にcheckedを付与する
 */
export default class FavoriteButton extends HTMLElement {

  constructor() {
    super();
    this.favorited = false;
  }

  connectedCallback() {
    const button = this.querySelector('button');
    const rootButton = this;

    // ボタンを非表示にしておく
    this.classList.add('hidden');

    window.addEventListener('load', () => {
      // 他の要素がロードされてから表示
      this.classList.remove('hidden');
    });

    

    button.addEventListener('click', (e) => {
      if (button.classList.contains('-is-checked')) {
        button.classList.remove('-is-checked');
        WLWishlistFunctions.removeFromWishList(e.target, { 
          epi: this.dataset.variantId, empi: this.dataset.productId, du: this.dataset.url
        })
      } else {
        button.classList.add('-is-checked');
        WLWishlistFunctions.addToList(e.target, { 
          epi: this.dataset.variantId, empi: this.dataset.productId, du: this.dataset.url
        })
      }
      setTimeout(() => {
        WLWishlistFunctions.fetchLists()
        }, 1000)
    });

    const type = this.getAttribute('type');
    if (type) {
      button.classList.add(`-type-${type}`);
    }
  }
  get checked() {
    return this.hasAttribute('checked');
  }

  set checked(value) {
    this.setAttribute('checked', value);
  }

  static counterUpdate(){
    fetch(location.pathname + '?section_id=' + document.querySelector('unico-header').dataset.id)
    .then((response) => response.text())
    .then((html) => {
      const dom = new DOMParser().parseFromString(html, 'text/html');
      document.querySelector('wl-wishlist-count').outerHTML = dom.querySelector('wl-wishlist-count').outerHTML;
    });
  }
}
